/**
 * Returns a function that returns true if the property is equal to the value
 * @template {object} T
 * @template {keyof T} K
 * @param {K} property - The property to check
 * @param {T[K]} value
 */
export function propertyEquals(property, value) {
  /**
   * @param {T} obj
   */
  return (obj) => obj?.[property] === value;
}

